import * as R from 'ramda'
import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { mapIndexed, notNilOrEmpty } from '../lib/helpers'

const carouselSettings = {
  autoplay: true,
  autoplaySpeed: 8000,
  adaptiveHeight: false,
  className: 'slider-component',
  centerMode: false,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
}

const SimpleSlider = props => (
  <section className="slider hero">
    {notNilOrEmpty(props) && (
      <Slider {...carouselSettings}>
        {mapIndexed((item, index) => (
          <React.Fragment key={index}>
            <div
              className="home-hero row d-flex align-items-center"
              style={{
                background: `url(${item.hero_img}) center / cover no-repeat`,
              }}
            >
              <div
                className={`hero-content-wrapper col-md-6 ${
                  R.equals(item.hero_text_position, 'right')
                    ? 'offset-6'
                    : 'text-right'
                }
              ${
                R.equals(item.hero_text_background, 'true')
                  ? 'hero-text-bg'
                  : ''
              }
              `}
              >
                <div
                  className="hero-content-container"
                  style={{
                    float: `${
                      R.equals(item.hero_text_position, 'left')
                        ? 'right'
                        : 'left'
                    }`,
                  }}
                >
                  <p>{item.hero_text}</p>
                  <Link
                    to={item.hero_link}
                    className="btn-primary btn"
                    style={{
                      color: '#fff',
                      fontFamily: 'TruenoSemiBold, serif',
                      fontSize: 22,
                    }}
                  >
                    {item.hero_button_text}
                  </Link>
                </div>
              </div>
            </div>
          </React.Fragment>
        ))(props.hero_slide)}
      </Slider>
    )}
  </section>
)

export default SimpleSlider
